import { RECEIVE_FORMS_DATA } from "../actions/formsActions";
import FormUrls from '../shared/formUrls';

const initialState = {
  formUrls: FormUrls
};

export default function formsReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FORMS_DATA:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/formsReducer.js